import cn from "classnames";
import { useState } from "react";
import { ChevronDown as ChevronDownIcon } from "@rshbintech.dboul/icons";
import { Text } from "../../../../../../text";
import { Dropdown, DropdownItemType } from "../../../../../../dropdown";
import { Button } from "../../../../../../button";
import { useMediaQuery } from "../../../../../../grid";
import { PageSizeSelectorProps } from "./types";
import styles from "./styles.module.scss";

export const PageSizeSelector = ({
  pageSize,
  availablePageSizes,
  dataTestId,
  onPageSizeChange,
}: PageSizeSelectorProps) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const xl = useMediaQuery("xl");
  const xxl = useMediaQuery("xxl");

  const toggleDropdownVisibility = () =>
    setIsDropdownVisible((currentVisibility) => !currentVisibility);

  const handlePageSizeChange = (newPageSize: number) => {
    setIsDropdownVisible(false);

    if (pageSize === newPageSize) {
      return;
    }

    onPageSizeChange(newPageSize);
  };

  const dropdownItems: DropdownItemType[] = availablePageSizes.map(
    (availablePageSize) => ({
      content: (
        <Text
          weight={availablePageSize === pageSize ? "medium" : "regular"}
          key={availablePageSize}
        >
          {availablePageSize}
        </Text>
      ),
      onClick: () => handlePageSizeChange(availablePageSize),
    })
  );

  return (
    <div className={styles["page-size-selector"]} data-test-id={dataTestId}>
      <Text className={styles["page-records-text"]}>Записей на странице: </Text>
      <Dropdown
        shown={isDropdownVisible}
        items={dropdownItems}
        onOutsideClick={() => setIsDropdownVisible(false)}
      >
        {/* TODO: Заменить на Button, когда решится вопрос с рефами в компонентах, обёрнутых в A11y */}
        <button
          onClick={toggleDropdownVisibility}
          type="button"
          className={styles["dropdown-toggle-button"]}
        >
          <Text size="medium">{pageSize}</Text>
          <ChevronDownIcon
            size={xl || xxl ? "large" : "medium"}
            className={cn(styles["arrow-down-icon"], {
              [styles.rotated]: isDropdownVisible,
            })}
          />
        </button>
      </Dropdown>
    </div>
  );
};
